import type { LimitPeriod } from '../../types';

const PERIOD_TRACK_TYPES = {
  DAY: 'Daily',
  WEEK: 'Weekly',
  MONTH: 'Monthly',
} as const;

const getTranslationKeyForPeriod = (period: LimitPeriod) => {
  switch (period) {
    case 'DAY':
      return 'daily';
    case 'WEEK':
      return 'weekly';
    case 'MONTH':
      return 'monthly';
  }
};

const getTrackTypeForPeriod = (period: LimitPeriod) => PERIOD_TRACK_TYPES[period];

export { getTrackTypeForPeriod, getTranslationKeyForPeriod };
